// extracted by mini-css-extract-plugin
export default {"mainContainer":"forgotPassword_mainContainer__4jV6i"};